export enum SERIE_TYPES {
  LINE = "line",
  BAR_STACKED = "bar-stacked",
  BAR_UNSTACKED = "bar-unstacked",
  AREA_STACKED = "area-stacked",
  AREA_UNSTACKED = "area-unstacked",
  NUMBER = "number",
}
